<template>
	<div class="main-table-all-back-wrap">
		<div class="pageList--wrap">
			<page-content-header
					@updateSearch="onSearch"
					@updateClick="onClick"
					@updateAllFilter="onAllFilter"
					:is-all-filter="isAllFilterActive"
					:is-all-filter-view="isAllFilterView"
					:title="pageTitle"
					:isPageTitle="isPageTitle"
					:isSearch="isSearch"
					:isCreate="isCreate"
					:isCreatePermissions="isCreatePermissions"
					:textCreate="textCreate"
					:isFilterRefresh="isFilterRefresh"
					:isSettings="isSettings"
					:isInfo="isInfo"
					:infoText="infoText"
					:isBackList="isBackList"
					:send="send"
					:isSend="isSend"
					:sendText="sendText"
					:exportList="exportList"
					:exportStart="exportStart"
					:isRefresh="isRefresh"
					:isExport="isExport"
					:isExportPermissions="isExportPermissions"
					:textReports="textReports"
					:selectConfig="selectConfig"
					:permissionsReports="permissionsReports"
					:permissionsCreate="permissionsCreate"
					:labelSearch="labelSearch"
			>
				<template #subTitle>
					<slot name="subTitle" />
				</template>
				<template #customButtons>
					<slot name="customButtons" />
				</template>
				<template #customSubButtons>
					<slot name="customSubButtons" />
				</template>
			</page-content-header>
			<div
					class="pageList--content"
					:class="[{ noPagination: getPageCount === 1 }]"
			>
				<div class="pageList--scroll">
					<table class="pageList--table" :class="flag">
						<t-head
								v-if="!hasAnyFilters || hasFiltersList"
								v-show="!headLoading"
								:class="{ isHidden: headLoading }"
								:flag="flag"
								:headers="headers"
								:filtersList="filtersList"
								:filterMod="filterModList"
								:selectedAllElements="selectedAllElements"
								:isFilterUpdate="filterUpdate"
								:isRefreshDate="refreshDate"
								:isDisabled="filterPreloader"
								:isRefresh="isRefresh"
								:sortDesc="getSort"
								:sortBy="getSortBy"
								:sortByDefault="defaultOrder"
								:filterClasses="filterClasses"
								:isIndexNumber="isIndexNumber"
								:checkAll="checkAll"
								:indeterminate="indeterminate"
								:list="list"
								:defaultFilter="defaultFilter"
								@updateChangeSorting="onChangeSorting"
								@updateChangeSort="changeSort"
								@updateCreateRefresh="createRefresh"
								@updateFilterCreated="filterCreated"
								@updateFilteredAll="onFilteredAll"
								@updatePerLoad="onPerLoad"
								@updateCheckOrders="onCheckOrders"
								@updateCounter="onCounter"
						></t-head>

						<thead v-show="headLoading" class="mainTableAllBack_thead loading">
							<tr>
								<th
										v-for="(item, index) in headersPreloader"
										:key="index"
										class="th"
										:class="[item.value, { 'lastTh': item.sticky }]"
								>
									<div class="controls" v-if="item.text">
										<div class="theadText" :class="[{ nowrap: item.nowrap }]">
											{{ item.text }}
										</div>
									</div>
								</th>
							</tr>
						</thead>
						<t-body
								v-if="list"
								:flag="flag"
								:checkAll="checkAll"
								:headers="headers"
								:headersChildren="headersChildren"
								:list="list"
								:isRefresh="isRefresh"
								:isRefreshCheckbox="isRefreshCheckbox"
								:filterClasses="filterClasses"
								:isCloseChildren="isCloseChildren"
								:isIndexNumber="isIndexNumber"
								:page="page"
								:limit="limitPagesLocal"
								:department_id="department_id"
								@updateEdit="onEdit"
								@updateChild="onChild"
								@updatePaid="onPaid"
								@updateClickButton="onClickButton"
								@updateModEvent="onModEvent"
								@updateCheckOrder="onCheckOrder"
								@updateCounter="onCounter"
						></t-body>

						<tfoot v-if="isTotalsLoading" class="mainTableAllBack_tfoot loading">
						<tr>
							<th v-if="isIndexNumber" :colspan="headers.length + 1"></th>
							<th v-else :colspan="headers.length"></th>
						</tr>
						</tfoot>

						<t-foot
								v-if="list && hasTotalsView"
								:isHide="isTotalsLoading"
								:flag="flag"
								:headers="headers"
								:totals="totalsView"
								:selected="selected"
								:filterClasses="filterClasses"
								:isIndexNumber="isIndexNumber"
						></t-foot>

					</table>
				</div>
			</div>
			<pagination
					v-if="totalPages && totalPages > limitPages"
					:length="totalPages"
					:pageCount="getPageCount"
					:itemsPerPage="itemsPerPage"
					:page="page"
					:isRefresh="isRefresh"
					:isRefreshPage="isRefreshPage"
					:pages="pages"
					@updatePagination="onPagination"
					@updateCountPagination="onCountPagination"
					isBack
			></pagination>
		</div>

		<all-filter
				v-if="isAllFilter"
				@updateCloseDialogAllFilter="onCloseDialogAllFilter"
				@updateSendAllFilter="onSendAllFilter"

				:flag="flag"
				:headers="headers"
				:filtersList="filtersListSave"
				:selectedAllElements="selectedAllElements"
				:isFilterUpdate="filterUpdate"
				:isRefreshDate="refreshDate"
				:isDisabled="filterPreloader"
				:isRefresh="isRefresh"
				:sortDesc="getSort"
				:sortBy="getSortBy"
				:sortByDefault="defaultOrder"
				:filterClasses="filterClasses"
				:isIndexNumber="isIndexNumber"
				:checkAll="checkAll"
				:indeterminate="indeterminate"
				:list="list"
				:defaultFilter="defaultFilter"
				:filterMod="filterModList"
				@updateChangeSorting="onChangeSorting"
				@updateChangeSort="changeSort"
				@updateCreateRefresh="createRefresh"
				@updateFilterCreated="filterCreated"
				@updateFilteredAll="onFilteredAll"
				@updatePerLoad="onPerLoad"
				@updateCheckOrders="onCheckOrders"
				@updateCounter="onCounter"
		/>

	</div>
</template>

<script>
import { mapGetters } from "vuex";
// components
import THead from "@/shared/MainTableAllBack/THead/THead";
import TBody from "@/shared/MainTableAllBack/TBody/TBody";
import TFoot from "@/shared/MainTableAllBack/TFoot/TFoot";
import Pagination from "@/shared/Pagination/Pagination";
import PageContentHeader from "@/shared/PageContentHeader/PageContentHeader";
// helper
import getUniqId from "@/helper/getUniqId";
import { PAGE } from "@/constants/constants";
import getClonedObject from "@/helper/getClonedObject";
import debounce from "lodash.debounce";
import AllFilter from "@/shared/MainTableAllBack/AllFilter/AllFilter.vue";
// import { applyChangeSort } from "@/utils/applyChangeSort";

export default {
	name: "MainTableAllBack",
	components: {
		AllFilter,
		THead,
		TBody,
		TFoot,
		Pagination,
		PageContentHeader,
	},
	props: {
		flag: String,
		pageTitle: String,
		headers: Array,
		department_id: Number,
		selected: Array,
		permissionsReports: Boolean,
		permissionsCreate: Boolean,
		selectConfig: Object,
		headersChildren: {
			type: Array,
			default: () => [],
		},
		checkAll: Boolean,
		indeterminate: Boolean,
		filtersList: {
			type: Object,
			default: () => ({})
		},
		list: Array,
		totals: Object,
		limitPages: {
			type: Number,
			default: () => 15
		},
		pages: {
			type: Array,
			default: () => [ 15, 20, 50, 100, 200, 500, "All" ],
		},
		totalPages: Number,
		isSettings: Boolean,
		textReports: String,
		isExport: Boolean,
		isExportPermissions: Boolean,
		uniqId: String,
		isFilterLoad: {
			type: Boolean,
			default: false,
		},
		isPageTitle: {
			type: Boolean,
			default: () => true
		},
		isAllFilterView: {
			type: Boolean,
			default: () => true
		},
		isSearch: {
			type: Boolean,
			default: true,
		},
		isCreate: {
			type: Boolean,
			default: true,
		},
		isCreatePermissions: Boolean,
		textCreate: {
			type: String,
			default: "Add new",
		},
		labelSearch: {
			type: String,
			default: "Search",
		},
		isFilterRefresh: {
			type: Boolean,
			default: true,
		},
		isInfo: Boolean,
		isDispatchReports: String,
		infoText: {
			type: String,
			default: "Info",
		},
		exportList: {
			type: Array,
			default: () => [],
		},
		exportStart: {
			type: Object,
			default: () => {
			},
		},
		isBackList: Boolean,
		defaultFilter: {
			type: Object,
			default: () => {
			},
		},
		defaultOrder: {
			type: String,
			default: "",
		},
		defaultSort: {
			type: String,
			default: "",
		},
		send: Boolean,
		isSend: Boolean,
		sendText: {
			type: String,
			default: "Send",
		},
		isIndexNumber: Boolean,
		// configRefresh: {
		// 	type: Object,
		// 	default: () => ({})
		// },
		externalResetKey: {
			type: [ String, Number ],
			default: null,
		},
		externalResetMode: {
			type: String,
			default: 'default', // 'default' | 'empty'
		},

		externalRefreshKey: {
			type: [ String, Number ],
			default: null,
		},

	},
	computed: {
		...mapGetters([ 'isChangeData' ]),

		hasFiltersList() {
			return !!(this.filtersList && Object.keys(this.filtersList).length);
		},

		headersPreloader() {
			const objCopy = getClonedObject(this.headers);
			const index_number = {
				text: "#",
				value: "index_number",
				func: false,
				sortable: false,
			};
			objCopy.unshift(index_number);

			if (this.isIndexNumber) return objCopy;
			return this.headers;
		},

		getPageCount() {
			const limit = this.limitPagesLocal;
			const total = this.totalPages;
			let count = 0;
			if (total < limit) {
				count = 1;
			} else if (total % limit === 0) {
				count = total / limit;
			} else {
				count = total / limit;
				count = Math.ceil(count);
			}

			return count;
		},

		getSortBy() {
			return this.order ? this.order : this.defaultOrder;
		},

		getSort() {
			const sort = this.sort ? this.sort : this.defaultSort;
			return sort === "desc";
		},

		filterClasses: {
			get() {
				return this.checkClasses;
			},
			set(arr) {
				const obj = {};
				for (const i in arr) {
					obj[i] = !!arr[i].length;
				}
				this.checkClasses = obj;
			},
		},

		hasTotalsView() {
			return !!(this.totalsView && Object.keys(this.totalsView).length);
		},

		isTotalsLoading() {
			// показываем лоадер только если:
			// 1) сейчас идёт запрос totalsPreloader
			// 2) и есть list
			return !!(this.totalsPreloader && this.list);
		},

		hasAnyFilters() {
			return Array.isArray(this.headers) && this.headers.some(h => !!h.func);
		},
		
		headLoading() {
			return this.hasAnyFilters && (!this.hasFiltersList || this.filterPreloader);
		},

	},
	watch: {
		reloadToken(val, oldVal) {
			if (val && val !== oldVal) {
				this.reloadTable({ mode: this.reloadMode, flag: 'external' });
			}
		},
		isDisabled(val) {
			if (val) this.menu = false;
		},
		// filtersList: {
		// 	deep: true,
		// 	immediate: true,
		// 	handler(val) {
		// 		// зберігаємо тільки 1 раз, коли справді прийшли дані
		// 		if (
		// 			(!this.filtersListSave || Object.keys(this.filtersListSave).length === 0) &&
		// 				val && Object.keys(val).length
		// 		) {
		// 			this.filtersListSave = getClonedObject(val);
		// 		}
		// 	}
		// },
		isChangeData(value, oldValue) {
			if (value !== oldValue) {
				this.sendChangeSortNow();
			}
		},
		isDispatchReports(value, oldValue) {
			if (value && value !== oldValue) {
				this.sendChangeSortNow('create');
			}
		},
		uniqId(value, oldValue) {
			if (value !== oldValue) {
				// this.onRefreshFilters(this.configRefresh);
				this.refreshWithCurrentFilters();
			}
		},
		// list: {
		// 	immediate: true,
		// 	handler() {
		// 		// ✅ як тільки батько оновив list — вважаємо, що запит завершився
		// 		if (this.filterPreloader) {
		// 			this.filterPreloader = false;
		// 		}
		// 	}
		// },

		filtersList: {
			deep: true,
			immediate: true,
			handler(val) {
				if (
					(!this.filtersListSave || Object.keys(this.filtersListSave).length === 0) &&
						val && Object.keys(val).length
				) {
					this.filtersListSave = getClonedObject(val);
				}

				if (val && Object.keys(val).length) {
					this.filterPreloader = false;
					clearTimeout(this.filtersLoadingTimer);
				}
			}
		},

		totals: {
			deep: true,
			immediate: true,
			handler(val) {
				// totals ещё не пришли или пустые — ничего не делаем
				if (!val || !Object.keys(val).length) return;

				// обновляем витрину (покажем новые totals)
				this.totalsView = getClonedObject(val);

				// выключаем лоадер
				this.totalsPreloader = false;
				clearTimeout(this.totalsLoadingTimer);
			}
		},

		externalRefreshKey(value, oldValue) {
			if (!value || value === oldValue) return;

			// ✅ включаем плейсхолдеры как при фильтрации
			this.startHeadLoading();
			this.startTotalsLoading();

			// ✅ перезапрашиваем с текущими выбранными фильтрами
			this.$emit("updateList", {
				value: getClonedObject(this.filterModList),
				flag: "externalRefresh",
			});
		},

		// externalResetKey(value, oldValue) {
		// 	if (!value || value === oldValue) return;
		// 	this.externalResetFilters();
		// },
		externalResetKey(val, oldVal) {
			if (!val || val === oldVal) return;

			// 1️⃣ включаем плейсхолдеры
			this.startHeadLoading();
			this.startTotalsLoading();

			// 2️⃣ полный reset внутреннего состояния
			this.resetFiltersInternal(this.externalResetMode);

			// 3️⃣ отправляем запрос
			this.$emit("updateRefreshFilters", getClonedObject(this.filterModList));

			// 4️⃣ обновляем UI
			this.isRefreshPage = getUniqId();
			this.isRefresh = getUniqId();
			this.isCloseChildren = getUniqId();
		},

		limitPages(val) {
			this.limitPagesLocal = val;
			this.itemsPerPage = val;
		},

	},
	data() {
		return {
			filtersListSave: {},
			theadResetToken: 0, // щоб примусово скинути локальний стан Thead/FilterTable
			filterModList: {
				limit: null,
				order: null,
				page: 1,
				sort: 'desc',
			},
			checkClasses: {},
			isCloseChildren: null,
			isDisabled: false,
			isRefreshPage: "",
			filtersMarker: {},
			filterUpdate: false,
			filters: {},
			selectedAllElements: { key: "", id: "" },
			refreshDate: null,
			isRefreshCheckbox: null,
			isRefresh: null,
			itemsPerPage: this.limitPages,
			page: 1,
			order: null,
			sort: null,
			isRefreshActive: true,
			isFilterPreloader: false,
			defaultFilterLocal: {},
			isAllFilter: false,
			isAllFilterActive: false,

			filterPreloader: true, // чтобы при первом заходе показывать thead loading
			totalsPreloader: true, // чтобы при первом заходе показывать totals loading
			totalsView: null, // витрина totals (чтобы скрывать старые totals)

			filtersLoadingTimer: null,
			totalsLoadingTimer: null,
			limitPagesLocal: this.limitPages,
		};
	},
	methods: {

		resetFiltersInternal(mode = 'default') {
			// очистка классов
			for (const key in this.filterClasses) {
				this.filterClasses[key] = false;
			}

			// очистка filterModList
			for (const key in this.filterModList) {
				if (key.includes('filter')) {
					this.filterModList[key] = [];
				}
			}

			// сброс пагинации
			this.page = 1;
			this.itemsPerPage = this.pages[0];
			this.limitPagesLocal = this.pages[0];

			// defaultFilter (если нужно)
			if (
				mode === 'default' &&
					this.defaultFilter &&
					Object.keys(this.defaultFilter).length
			) {
				Object.assign(this.filterModList, getClonedObject(this.defaultFilter));
				this.initializeCheckClasses();
			}
		},

		externalResetFilters() {
			// включаем плейсхолдеры как при фильтрации
			this.startHeadLoading();
			this.startTotalsLoading();

			// полностью повторяем логику reset как внутри таблицы
			// используем onRefreshFilters (он чистит классы, сбрасывает, триггерит isRefresh, isCloseChildren и т.д.)
			// главное: режим "limit: true"
			// this.onRefreshFilters(this.configRefresh);
			this.onRefreshFilters({}, 'default');

			// если нужно принудительно вернуть дефолты (на всякий)
			if (this.externalResetMode === 'default') {
				if (this.defaultFilterLocal && Object.keys(this.defaultFilterLocal).length) {
					Object.assign(this.filterModList, getClonedObject(this.defaultFilterLocal));
					this.initializeCheckClasses();
				}
			}

			// закрыть все селекты/дропдауны
			this.isCloseChildren = getUniqId();
		},

		refreshWithCurrentFilters() {
			this.startHeadLoading();
			this.startTotalsLoading();

			this.$emit("updateList", {
				value: getClonedObject(this.filterModList),
				flag: "externalRefresh",
			});
		},

		startHeadLoading() {
			if (!this.hasAnyFilters) {
				this.filterPreloader = false;
				return;
			}
			this.filterPreloader = true;
			clearTimeout(this.filtersLoadingTimer);
			this.filtersLoadingTimer = setTimeout(() => {
				this.filterPreloader = false;
			}, 25000);
		},

		startTotalsLoading(options) {
			const keepOld = options && options.keepOld;
			// прячем старые totals только если НЕ сказали сохранить
			if (!keepOld) this.totalsView = null;

			// включаем прелоадер
			this.totalsPreloader = true;

			// страховка от залипания
			clearTimeout(this.totalsLoadingTimer);
			this.totalsLoadingTimer = setTimeout(() => {
				this.totalsPreloader = false;
			}, 25000);
		},

		sendChangeSortNow(flag, fromAllFilters) {
			const skipLoading = (flag === 'page' || flag === 'sorting');

			if (!skipLoading) {
				this.startHeadLoading();
				this.startTotalsLoading();
			}

			this._sendChangeSortDebounced(flag, fromAllFilters);
		},

		_sendChangeSortDebounced: debounce(function(flag, fromAllFilters) {
			if (!fromAllFilters) {
				this.isAllFilterActive = false;
			}

			this.defaultFilterList();

			if (this.itemsPerPage === 'All') {
				this.filterModList.limit = 999999;
			}

			this.$emit("updateList", { value: this.filterModList, flag });

			if (flag !== "page") this.isRefreshPage = getUniqId();
		}, 600),

		clearFiltersBeforeSearch() {
			// 1) скидаємо класи активності фільтрів
			for (const key in this.filterClasses) {
				this.filterClasses[key] = false;
			}

			// 2) скидаємо значення фільтрів у filterModList
			// чистимо тільки "filter_*" поля (як у твоєму onRefreshFilters)
			for (const key in this.filterModList) {
				if (key.includes('filter')) {
					// якщо фільтр був обʼєктом (date/number) — скидаємо в порожній обʼєкт
					if (this.filterModList[key] && typeof this.filterModList[key] === 'object' && !Array.isArray(this.filterModList[key])) {
						this.filterModList[key] = {};
					} else {
						// інакше — масивом
						this.filterModList[key] = [];
					}
				}
			}

			// 3) якщо є defaultFilter — повертаємо дефолти (якщо треба)
			// Якщо при пошуку ти НЕ хочеш дефолти — цей блок прибери

			// if (this.defaultFilter && Object.keys(this.defaultFilter).length > 0) {
			// 	Object.assign(this.filterModList, getClonedObject(this.defaultFilterLocal));
			// 	this.initializeCheckClasses();
			// }
		},

		onCloseDialogAllFilter() {
			this.isAllFilter = false;
		},

		onSendAllFilter(payload) {
			const { filter, filterClass } = payload;

			Object.assign(this.filterModList, filter);
			Object.assign(this.filterClasses, filterClass);

			this.isAllFilterActive = true;
			this.sendChangeSortNow(null, true);

			this.isAllFilter = false;
			this.isCloseChildren = getUniqId();
		},
		onAllFilter() {
			this.isAllFilter = true;
		},
		onClick(args) {
			const { flag, value } = args;
			if (flag === "refresh") {
				this.startHeadLoading();
				this.startTotalsLoading();

				// reset до дефолтных + запрос
				this.onRefreshFilters({}, 'default');
			}
			if (flag === "settings") this.$emit("updateSettings");
			if (flag === "create") this.$emit("updateCreate");
			if (flag === "info") this.$emit("updateInfo");
			if (flag === "back") this.$emit("updateBack");
			if (flag === "send") this.$emit("updateSend");
			if (flag === "export") this.$emit("updateExport", this.filterModList);

			if (flag === "exportList") {
				this.filterModList["fileType"] = value.id;
				this.$emit("updateExportList", this.filterModList);
			}

			this.$emit("updateEvent", flag);
		},
		onCounter(values) {
			this.$emit('updateCounter', values);
		},
		// onCheckOrder(a, b) {
		// 	// Вариант 1: пришло (id, line)
		// 	if ((typeof a === 'number' || typeof a === 'string') && b && typeof b === 'object') {
		// 		this.$emit('updateCheckOrder', a, b);
		// 		return;
		// 	}
		//
		// 	// Вариант 2: пришло ({ id, line }) или ({ line })
		// 	if (a && typeof a === 'object') {
		// 		const id = a.id != null ? a.id : null;
		// 		const line = a.line != null ? a.line : a;
		//
		// 		this.$emit('updateCheckOrder', id, line);
		// 		return;
		// 	}
		//
		// 	// Вариант 3: пришло только id
		// 	this.$emit('updateCheckOrder', a, null);
		// },
		// onCheckOrders(value) {
		// 	if (value) {
		// 		this.selectedCustomers = this.list
		// 			.map(function(row) {
		// 				return row.customer_id;
		// 			})
		// 			.filter(function(id) {
		// 				return id != null;
		// 			});
		// 	} else {
		// 		this.selectedCustomers = [];
		// 	}
		//
		// 	this.syncCheckStates();
		// },

		onCheckOrder({ line }) {
			this.$emit('updateCheckOrder', line);
		},
		onCheckOrders(value) {
			this.$emit('updateCheckOrders', value);
		},

		// onSearch(value) {
		// 	this.filterModList["search"] = value;
		// 	this.page = 1;
		// 	this.sendChangeSort();
		// },

		onSearch(value) {
			this.startHeadLoading();
			this.startTotalsLoading();

			// ✅ НЕ трогаем filter_* — оставляем выбранные
			this.filterModList.search = value;
			this.page = 1;

			this.isCloseChildren = getUniqId();
			this.sendChangeSortNow();
		},

		onPerLoad() {
			this.$emit("updatePerLoad");
		},
		onEdit(value) {
			this.$emit("updateEdit", value);
		},
		onChild(value) {
			this.$emit("updateChild", value);
		},
		onPaid(values) {
			this.$emit('updatePaid', values);
		},
		onClickButton(values) {
			this.$emit("updateClickButton", values);
		},
		onModEvent(args) {
			this.$emit('updateModEvent', args);
		},
		onChangeSorting({ sortBy, sortDesc }) {
			this.page = 1;
			this.order = sortBy;
			this.sort = sortDesc ? "desc" : "asc";
			this.sendChangeSortNow("sorting");
		},
		// changeSort(payload) {
		// 	applyChangeSort(this, payload, getUniqId);
		// },
		changeSort({ key, value, model }) {
			// при редактировани добавить проверки и в общем фильтре src/shared/MainTableAllBack/AllFilter/AllFilter.vue

			switch (model) {
				case "date":
					this.filterModList[key] = value;
					this.filterClasses[key] = !!this.filterModList[key]["from"];
					break;
				case "number":
					this.filterModList[key] = value;
					this.filterClasses[key] = !!this.filterModList[key]["type"];
					break;
				case "note":
					this.filterModList[key] = value;
					this.filterClasses[key] = !!this.filterModList[key].length;
					break;
				case "options":
					this.filterModList[key] = Number(value);
					this.filterClasses[key] = !!this.filterModList[key].length;
					break;
				case "address":
					this.filterModList[key] = value.map((item) => item);
					this.filterClasses[key] = !!this.filterModList[key].length;
					break;
				case "addressType":
					this.filterModList[key] = value;
					this.filterClasses[key] = !!this.filterModList[key].length;
					break;
				case "checkbox":
					this.filterClasses[key] = Number(value);
					this.filterModList[key] = value;
					break;
				case "list":
					this.filterModList[key] = value.map((item) => item);
					this.filterClasses[key] = !!this.filterModList[key].length;
					break;
				default:
					this.filterModList[key] = value;
					this.filterClasses[key] = !!this.filterModList[key].length;
			}

			this.page = 1;
			this.sendChangeSortNow();
			this.isCloseChildren = getUniqId();
		},
		defaultFilterList() {
			// if (this.defaultFilter) {
			// 	Object.assign(this.filterModList, getClonedObject(this.defaultFilter));
			// }
			this.filterModList.order = this.order ?? this.defaultOrder;
			this.filterModList.sort = this.sort ?? this.defaultSort;
			this.filterModList.limit = this.itemsPerPage ?? this.limitPagesLocal;
			this.filterModList.page = this.page;
		},
		// sendChangeSort: debounce(function(flag, fromAllFilters) {
		// 	if (!fromAllFilters) {
		// 		this.isAllFilterActive = false;
		// 	}
		// 	this.defaultFilterList();
		//
		// 	if (this.itemsPerPage === 'All') {
		// 		this.filterModList.limit = 999999;
		// 	}
		//
		// 	this.filterPreloader = true;
		//
		// 	this.isDisabled = true;
		// 	this.$emit("updateList", { value: this.filterModList, flag });
		// 	this.isDisabled = false;
		// 	if (flag !== "page") this.isRefreshPage = getUniqId();
		// 	this.filterPreloader = false;
		// }, 600),

		// sendChangeSort: debounce(function(flag, fromAllFilters) {
		// 	if (!fromAllFilters) {
		// 		this.isAllFilterActive = false;
		// 	}
		//
		// 	this.defaultFilterList();
		//
		// 	if (this.itemsPerPage === 'All') {
		// 		this.filterModList.limit = 999999;
		// 	}
		//
		// 	// ✅ показати loading thead на час запиту
		// 	this.filterPreloader = true;
		//
		// 	this.$emit("updateList", { value: this.filterModList, flag });
		//
		// 	if (flag !== "page") this.isRefreshPage = getUniqId();
		//
		// 	// ❌ НЕ вимикаємо тут filterPreloader
		// }, 600),

		createRefresh(model) {
			this.filtersMarker[model] = true;
			if (!Object.values(this.filtersMarker).includes(false)) {
				this.filterUpdate = false;
				for (const i in this.filtersMarker) {
					this.filtersMarker[i] = true;
				}
			}
			this.filterClasses = this.filters;
		},
		filterCreated(model) {
			this.filtersMarker[model] = false;
		},
		onFilteredAll(item) {
			this.filterCreated(item);
		},
		onRefreshFilters(config = {}, mode = "default") {
			this.isRefreshActive = false;
			this.order = null;
			this.sort = null;

			this.refreshDate = getUniqId();
			this.page = 1;
			this.filterModList.search = "";
			this.isAllFilterActive = false;

			this.defaultFilterList();

			for (const variable in this.filterModList) {
				const isDelete = !config[variable];
				if (isDelete) {
					this.filterClasses[variable] = false;
					if (variable.includes("filter")) this.filterModList[variable] = [];
				}
			}

			if (mode === "default" && this.defaultFilterLocal && Object.keys(this.defaultFilterLocal).length > 0) {
				Object.assign(this.filterModList, getClonedObject(this.defaultFilterLocal));
				this.initializeCheckClasses();
			}

			const savedLimit = this.limitPages;
			const fallbackLimit = this.pages && this.pages.length ? this.pages[0] : 20;
			const nextLimit = savedLimit || fallbackLimit;

			this.filterModList.limit = nextLimit;
			this.limitPagesLocal = nextLimit;
			this.itemsPerPage = nextLimit;

			this.$emit("updateRefreshFilters", this.filterModList);
			this.isRefreshPage = getUniqId();
			this.isRefresh = getUniqId();
			this.isCloseChildren = getUniqId();
		},

		onPagination(value) {
			this.$emit('updateCheckAll');
			this.isRefreshCheckbox = getUniqId();
			this.page = value;
			this.sendChangeSortNow("page");
		},
		onCountPagination(value) {
			this.$emit("updateCheckAll");
			this.isRefreshCheckbox = getUniqId();
			this.page = 1;
			this.itemsPerPage = value;

			this.$emit("updateRowsPerPage", value);

			this.sendChangeSortNow("page");
		},
		getFilterModList() {
			if (
				this.flag === PAGE.DISPATCH_STATISTICS ||
					this.flag === PAGE.INVOICE ||
					this.flag === PAGE.EMPLOYEES ||
					this.flag === PAGE.TRUCKS ||
					this.flag === PAGE.TRAILERS ||
					this.flag === PAGE.PAYMENTS_CUSTOMER ||
					this.flag === PAGE.LOST_PAYMENTS ||
					this.flag === PAGE.CUSTOMER_INVOICE_ITEMS ||
					this.flag === PAGE.DRIVERS ||
					this.flag === PAGE.BROKERS ||
					this.flag === PAGE.USERS ||
					this.flag === PAGE.CITIES ||
					this.flag === PAGE.TRIP_LIST ||
					this.flag === PAGE.CUSTOMERS ||
					this.flag === PAGE.LOGBOOKSMOD ||
					this.flag === 'customersBulkChange' ||
					this.flag === 'incomeTransactions' ||
					this.flag === PAGE.MANAGER_STATEMENTS
			) {
				for (const key in this.filtersList) {
					this.filterModList[key] = [];
				}

				// } else if (this.flag === PAGE.EMPLOYEES) {
				// 	// for (const key in this.filtersList) {
				// 	// 	this.filterModList[key] = [];
				// 	// }
				// 	this.filterModList.filter_active = [ 1 ];
				// 	this.filterClasses.filter_active =
				// 			!!this.filterModList.filter_active.length;
				// 	this.sendChangeSort();

			} else if (this.flag === PAGE.LOGBOOKS) {
				this.filterModList.filter_status_serves = [ 1 ];
				this.filterClasses.filter_status_serves =
						!!this.filterModList.filter_status_serves.length;
				this.sendChangeSortNow();
			} else {
				this.sendChangeSortNow();
			}
		},

		initializeCheckClasses() {
			if (!this.defaultFilter || Object.keys(this.defaultFilter).length === 0) return;

			const newCheckClasses = {};

			for (const key in this.defaultFilter) {
				const value = this.defaultFilter[key];

				if (Array.isArray(value)) {
					newCheckClasses[key] = value.length > 0;
				} else if (value && typeof value === 'object') {
					if ('from' in value) {
						newCheckClasses[key] = !!value.from;
					} else if ('type' in value) {
						newCheckClasses[key] = !!value.type;
					} else {
						newCheckClasses[key] = true;
					}
				} else {
					newCheckClasses[key] = !!value;
				}
			}

			this.checkClasses = newCheckClasses;
		}
	},
	mounted() {
		this.filtersListSave = getClonedObject(this.filtersList);

		// 1) підготуємо пусті ключі під всі фільтри
		this.getFilterModList();

		// 2) застосуємо дефолт ОДИН раз (тільки на старті)
		if (this.defaultFilter && Object.keys(this.defaultFilter).length > 0) {
			this.defaultFilterLocal = getClonedObject(this.defaultFilter);
			Object.assign(this.filterModList, getClonedObject(this.defaultFilterLocal));
			this.initializeCheckClasses();
		}

		// 3) проставимо order/sort/limit/page (без дефолт-фільтрів!)
		this.defaultFilterList();
	},
};
</script>

<style lang="scss">
@import "mainTableAllBack";
.isHidden {
	visibility: hidden;
	pointer-events: none;
}
</style>
